module.exports = __webpack_public_path__ + "static/img/81069A_R_all_20170815_LC.8297a08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/81069A_R_all_20170815_LC.png
// module id = aMi/
// module chunks = 0